import {
  ButtonStyles,
  Primary,
  Secondary,
  Green,
  Back,
  Outline,
  Register,
  PrimaryResults,
  PrimaryTable,
  Cancel,
  OrangeSenne,
  Loggin,
  AzulSenne,
  Gray,
  ButtonArc,
  Danger
} from "./style";

import type { IButtonDivParams, IButtonParams, IGoBackButtonParams } from "./types";
import LeftArrowIcon from "../../assets/icons/LeftArrowIcon";

function PrimaryButton({ children, ...props }: IButtonParams) {
  return (
    <>
      <ButtonStyles />
      <Primary {...props}>{children}</Primary>
    </>
  );
}
function AzulSenneButton({ children, ...props }: IButtonParams) {
  return (
    <>
      <ButtonStyles />
      <AzulSenne {...props}>{children}</AzulSenne>
    </>
  );
}

function OrangeSenneButton({ children, ...props }: IButtonParams) {
  return (
    <>
      <ButtonStyles />
      <OrangeSenne {...props}>{children}</OrangeSenne>
    </>
  );
}

function PrimaryResultsButton({ children, ...props }: IButtonParams) {
  return (
    <>
      <ButtonStyles />
      <PrimaryResults {...props}>{children}</PrimaryResults>
    </>
  );
}

function GrayButton({ children, ...props }: IButtonParams) {
  return (
    <>
      <ButtonStyles />
      <Gray {...props}>{children}</Gray>
    </>
  );
}

function CancelButton({ children, ...props }: IButtonParams) {
  return (
    <>
      <ButtonStyles />
      <Cancel {...props}>{children}</Cancel>
    </>
  );
}

function TableButton({ children, ...props }: IButtonParams) {
  return (
    <>
      <ButtonStyles />
      <PrimaryTable {...props}>{children}</PrimaryTable>
    </>
  );
}

function RegisterButton({ children, ...props }: IButtonParams) {
  return (
    <>
      <ButtonStyles />
      <Register {...props}>{children}</Register>
    </>
  );
}

function SecondaryButton({ children, ...props }: IButtonParams) {
  return (
    <>
      <ButtonStyles />
      <Secondary {...props}>{children}</Secondary>
    </>
  );
}

function GreenButton({ children, ...props }: IButtonParams) {
  return (
    <>
      <ButtonStyles />
      <Green {...props}>{children}</Green>
    </>
  );
}

function GoBackButton({ click }: IGoBackButtonParams) {
  return (
    <>
      <ButtonStyles />
      <Back type="button" onClick={click}>
        <LeftArrowIcon />
        Voltar
      </Back>
    </>
  );
}

function OutlineButton({ children }: IButtonParams) {
  return (
    <>
      <ButtonStyles />
      <Outline>{children}</Outline>
    </>
  );
}

function LogginButton({ children, ...props }: IButtonDivParams) {
  return (
    <>
      <ButtonStyles />
      <Loggin {...props}>{children}</Loggin>
    </>
  );
}

function DangerButton({ children, ...props }: IButtonParams) {
  return (
    <>
      <ButtonStyles />
      <Danger {...props}>{children}</Danger>
    </>
  );
}

function Button({ children, ...props }: IButtonParams) {
  return (
    <>
      <ButtonStyles />
      <ButtonArc {...props}>{children}</ButtonArc>
    </>
  );
}

export {
  PrimaryButton,
  SecondaryButton,
  AzulSenneButton,
  DangerButton,
  GreenButton,
  GoBackButton,
  OutlineButton,
  RegisterButton,
  PrimaryResultsButton,
  TableButton,
  CancelButton,
  OrangeSenneButton,
  LogginButton,
  GrayButton,
  Button,
};
